<template>
  <div class='config-card'>
    <div
      class='header collapsed'
      data-toggle='collapse'
      data-target='#config'
      aria-controls='config'>
      Config
      <i class="far fa-angle-up" />
    </div>
    <div class='config-link'>
      <span class='text-dark' v-show='!geogrid.attrs.locationPath && !config.attrs.locationPath'>
        {{ geogrid.attrs.businessName || config.trackedBusiness }}
      </span>
      <a
        :href='geogrid.attrs.locationPath || config.attrs.locationPath'
        v-show='geogrid.attrs.locationPath || config.attrs.locationPath'
        target='_blank'>
        {{ geogrid.attrs.businessName }}
        <small><i class='far fa-external-link' /></small>
      </a>
      <a
        href='javascript:void(0);'
        v-show='config.attrs.businessLocationLat'
        class='ml-2'
        @click='toggleShowBusinessLocation'>
        <i class="far fa-map-marker" />
      </a>
    </div>
    <div id="config" class="config-card-description collapse">
      <div>
        <tags
          ref='tags'
          :show-edit-buttons='true'
          :add-tag-path='config.addTagPath'
          :remove-tag-path='config.removeTagPath' />
      </div>
      <div class="mb-2">
        <span class='label'>place ID:</span>
        <p class='text-break'>{{ geogrid.attrs.businessPlaceId || config.attrs.businessPlaceId }}</p>
        <span class='label'>next generation:</span>
        <p>{{ config.nextGeneration }}</p>
        <span class='label'>schedule:</span>
        <p>{{ config.scheduleFormatted }}</p>
        <template v-if='config.labels && config.labels.length'>
          <div class='label my-2'>
            <span class='location-labels-caption'>
              <img src='/packs/images/852296e025cf04825756.svg' alt=''>
              Label:
            </span>
          </div>
          <div class='location-labels'>
            <span v-for='label in config.labels' :key='`${label}${config.obfuscatedId}`' class='location-labels-item'>{{ label }}</span>
          </div>
        </template>
        <span class='label' v-show='openNote || note.length'>note:</span>
        <div class="scroll ver" :class="{'config-note': !openNote}">
          <quick-edit
            empty-text='note:'
            type='textarea'
            class="my-2"
            :classes='vueQuickEditClasses'
            :show-buttons='false'
            @show='resizeNote'
            @close='updateNote'
            v-model='note' />
        </div>
      </div>
      <button class='btn btn-sm' @click='repeatConfig'>
        <i class="far fa-copy mr-2" />
        Duplicate config
      </button>
    </div>
  </div>
</template>

<script>
import QuickEdit from 'vue-quick-edit'
import toastr from 'toastr'
import axios from 'axios'
import { BDropdown, BDropdownItem } from 'bootstrap-vue'
import Vue from 'vue'
import { mapMutations, mapState } from 'vuex'
import { DEFAULT_ERROR_MESSAGE } from '../../../../common/constants'
import tags from '../../components/tags'

Vue.component('BDropdown', BDropdown)
Vue.component('BDropdownItem', BDropdownItem)
Vue.component('QuickEdit', QuickEdit)
export default {
  name: 'Config',
  components: { tags },
  props: {
    apiGeogridsPath: String,
    geogridsPath: String
  },
  data() {
    return {
      vueQuickEditClasses: {
        link: 'text-break vue-quick-edit__link',
        input: 'form-control form-control-sm textareaClass'
      },
      note: '',
      gifDate: null,
      getGifLink: null,
      generateGifLink: null,
      placesDataSources: {
        crawl: 'Standard search',
        placesApi: 'Google Places API Key'
      },
      openNote: false
    }
  },
  computed: mapState(['config', 'geogrid']),
  watch: {
    config(newVal) {
      if (!newVal.obfuscatedId) return
      this.note = newVal.note || ''
      this.schedule = newVal.scheduleFormatted
      this.$refs.tags.renderTags(newVal.tags)
    }
  },
  methods: {
    ...mapMutations([
      'toggleBusinessMarker',
      'repeatConfig'
    ]),
    updateNote() {
      this.openNote = false
      const noteWithNoEmptyLines = this.textarea.value.toString().trim()
      this.config.note = noteWithNoEmptyLines
      this.note = noteWithNoEmptyLines
      axios.patch(this.config.updateNotePath, { note: noteWithNoEmptyLines }).catch((_error) => {
        toastr.error(DEFAULT_ERROR_MESSAGE)
      })
    },
    resizeNote() {
      this.openNote = true
      this.$nextTick(() => {
        [this.textarea] = $('.textareaClass')
        this.textarea.style.cssText = `height: ${this.textarea.scrollHeight}px`
        this.textarea.addEventListener('input', this.resizeNote)
      })
    },
    toggleShowBusinessLocation() {
      if (this.config.attrs.businessLocationLat) this.toggleBusinessMarker(this.config.attrs)
    }
  }
}
</script>
